// @flow

import React from 'react'
import ButtonBase from 'components/atoms/Button/ButtonBase'

function getButton(props) {
  switch (props.buttonType) {
    case 'small':
      return (
        <ButtonBase
          fontSizeSp={14}
          fontSizePc={12}
          paddingSp={'11px 16px'}
          paddingPc={'8px 16px'}
          lineHeightSp={18}
          lineHeightPc={16}
          {...props}
          fullWidthSp={props.fullWidthSp || false}
          fullWidthPc={props.fullWidthPc || false}
        >
          {props.children}
        </ButtonBase>
      )
    case 'medium':
      return (
        <ButtonBase
          fontSizeSp={14}
          paddingSp={'13px 16px'}
          paddingPc={'11px 16px'}
          lineHeightSp={18}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'large':
      return (
        <ButtonBase
          fontSizePc={16}
          paddingSp={'13px 16px'}
          lineHeightPc={16}
          lineHeightSp={20}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'huge':
      return (
        <ButtonBase
          fontSizePc={16}
          paddingSp={'12px 16px'}
          paddingPc={'16px'}
          lineHeightPc={16}
          lineHeightSp={20}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'onlyIconSmall':
      return (
        <ButtonBase
          fontSizeSp={14}
          fontSizePc={12}
          buttonWidthSp={40}
          buttonWidthPc={32}
          buttonHeightSp={40}
          buttonHeightPc={32}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'onlyIconLarge':
      return (
        <ButtonBase
          buttonWidthSp={40}
          buttonHeightSp={40}
          fontSizePc={14}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    default:
      return <ButtonBase {...props}>{props.children}</ButtonBase>
  }
}

type PropTypes = {
  fontSizeSp?: number,
  fontSizePc?: number,
  paddingSp?: string,
  paddingPc?: string,
  lineHeightSp?: number,
  lineHeightPc?: number,
  isOnlyBorder?: boolean,
  children?: any,
  buttonType?: string,
  onClick: Function,
}

export default (props: PropTypes) => getButton(props)



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.jsx